import React from "react"

import { getGrowthChange, toStatNumber } from "../../utils/growthChange"

function TrendUpIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
      />
    </svg>
  )
}

function TrendDownIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"
      />
    </svg>
  )
}

const GrowthChange = ({
  change,
  className = "",
  iconClassName = "h-4 w-4 flex-shrink-0",
  labelClassName = "text-[10px] leading-none",
}) => {
  if (!change) return null
  const Icon =
    change.direction === "up"
      ? TrendUpIcon
      : change.direction === "down"
      ? TrendDownIcon
      : null

  return (
    <span
      className={`inline-flex items-center gap-0.5 ${className} ${
        change.className || ""
      }`}
    >
      {Icon ? <Icon className={iconClassName} /> : null}
      <span className={labelClassName}>{change.label}</span>
    </span>
  )
}

export { GrowthChange, getGrowthChange, toStatNumber }
